export default "__VITE_ASSET__82fd8f2a__"